import * as React from "react"

function Attempt({props , width = 19 , height=20}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.274 5.597c.382-.28.787-.513 1.217-.74l-.203.572a1.015 1.015 0 001.742.982l2.462-3.014.027-.032a1.413 1.413 0 00-.646-2.229L8.658.053a1.021 1.021 0 00-.998 1.733l.331.29c-.766.12-1.55.33-2.274.684-.704.288-1.328.73-1.95 1.171-.581.49-1.147 1.01-1.618 1.612A9.777 9.777 0 00.206 9.63a9.827 9.827 0 00-.174 1.114c-.01.365-.044.775-.028 1.092.033.656.064 1.311.161 1.974a1.034 1.034 0 001.988.22c.24-.624.415-1.257.59-1.89.159-.6.33-1.087.54-1.604.431-1.002.953-1.942 1.642-2.758.659-.837 1.46-1.553 2.35-2.18zm10.879.433a1.034 1.034 0 00-1.988-.22c-.24.624-.414 1.257-.59 1.89-.158.601-.33 1.087-.54 1.604-.43 1.003-.953 1.943-1.641 2.758-.66.837-1.46 1.553-2.35 2.18-.382.281-.787.513-1.217.741l.203-.572a1.015 1.015 0 00-1.742-.982l-2.462 3.013-.027.032a1.413 1.413 0 00.647 2.229l3.214 1.083a1.02 1.02 0 00.998-1.733l-.331-.29c.766-.12 1.55-.33 2.274-.684.705-.288 1.329-.73 1.95-1.171.582-.49 1.147-1.01 1.619-1.612a9.777 9.777 0 001.942-4.086c.086-.367.132-.743.175-1.114.01-.365.043-.774.027-1.092-.033-.656-.064-1.311-.161-1.974z"
        fill="#fff"
      />
    </svg>
  )
}

export default Attempt
